import { useState } from 'react';
import { Outlet } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
//
import Header from './header';
import Nav from './nav';

// const StyledBackground = styled('div')`
//   background-image: url('/assets/backgroundImg/layered-waves-haikei.svg');
//   zindex: -1;
//   position: absolute;
//   min-width: 100%;
//   min-height: 100%;
//   background-repeat: no-repeat;
//   object-fit: cover;
//   background-position: center;
// `;
// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 100;
const APP_BAR_DESKTOP = 100;

const StyledRoot = styled('div')({
    display: 'flex',
    minHeight: '100%',
    overflow: 'hidden',
});

const Main = styled('div')(({ theme }) => ({
    // backgroundColor: '#f2f7ff',
    flexGrow: 1,
    overflow: 'overlay',
    minHeight: '100%',
    backgroundColor: '#f2f7ff',
    paddingTop: APP_BAR_MOBILE + 24,
    paddingBottom: theme.spacing(10),
    [theme.breakpoints.up('lg')]: {
        paddingTop: APP_BAR_DESKTOP + 24,
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
    const [open, setOpen] = useState(false);

    return (
        <StyledRoot>
            <Header onOpenNav={() => setOpen(true)} />
            <Nav openNav={open} onCloseNav={() => setOpen(false)} />
            <Main>
                <Outlet />
            </Main>
        </StyledRoot>
    );
}
